import { Link as RouterLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@xinosolutions/xs-auth-react";
import LanguageSwitcher from "../GeneralComponents/LanguageSwitcher";
import ThemeToggle from "../GeneralComponents/ThemeToggle";
import CreateAccountLink from "../auth/CreateAccountLink";
import usePortalBranding from "../../Hooks/usePortalBranding";
import PortalSessionLoader from "./PortalSessionLoader";

export default function SiteHeader() {
  const { t } = useTranslation();
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();
  const { brandName, logoSrc } = usePortalBranding();

  const isHome = location.pathname === "/";

  return (
    <header className="portal-header">
      <RouterLink to="/" className="portal-logo">
        <img
          src={logoSrc}
          alt={brandName}
          className="portal-logo-image"
          decoding="async"
        />
        <span className="portal-logo-text">{brandName}</span>
      </RouterLink>

      <nav className="portal-nav" aria-label="Primary">
        <RouterLink to="/" className={isHome ? "portal-link" : undefined}>
          {t("landing.home")}
        </RouterLink>
        <RouterLink
          to="/verify"
          className={location.pathname.startsWith("/verify") ? "portal-link" : undefined}
        >
          {t("landing.verifyCertificate", "Verify Certificate")}
        </RouterLink>
        {!loading && isAuthenticated ? (
          <RouterLink
            to="/dashboard"
            className={location.pathname.startsWith("/dashboard") ? "portal-link" : undefined}
          >
            {t("landing.dashboard")}
          </RouterLink>
        ) : null}
      </nav>

      <div className="portal-header-actions">
        {loading ? (
          <PortalSessionLoader />
        ) : isAuthenticated ? (
          <RouterLink to="/dashboard" className="portal-btn portal-btn--primary">
            {t("landing.openDashboard")}
          </RouterLink>
        ) : (
          <CreateAccountLink className="portal-btn portal-btn--primary">
            {t("landing.getStarted")}
          </CreateAccountLink>
        )}
        <LanguageSwitcher />
        <ThemeToggle variant="header" />
      </div>
    </header>
  );
}
